export const IDEA_LIST_ROW = 'IdeaListRow'
